import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import CodespaceForm from 'Services/ControlDataManagement/Features/Codespace/Components/CodespaceForm'
import {
  useGetSingleCodespaceQuery,
  useUpdateSingleCodespaceMutation
} from 'Services/ControlDataManagement/Features/Codespace/codespaceApi'
import { SELECTED_CODESPACE_PARAMETER_KEY } from 'Services/ControlDataManagement/Features/Codespace/Hooks/useCodespacesWithParams'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function CodespaceEditPage() {
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/codespaces`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_CODESPACE_PARAMETER_KEY}=${id}`
  )
  const [, { isLoading: submitLoading }] = useUpdateSingleCodespaceMutation()
  const { data: singleCodespace, isLoading } = useGetSingleCodespaceQuery(id ?? '', {
    skip: !id
  })

  const breadcrumbs = [
    {
      title: t`Home`,
      link: CONTROL_DATA_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Codespaces`,
      link: baseUrl
    },
    {
      title: t`Edit codespace`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit codespace`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <CodespaceForm
          codespace={singleCodespace}
          successBaseUrl={previousLocation}
          submitLoading={submitLoading}
        />
      </WithLoader>
    </Box>
  )
}
